export default "__VITE_ASSET__DtcIAeed__"